import $ from 'jquery';

$.addInit(function(context){
	$('.b-map', context).each(function(){
		if (!ymaps) {
			console.warn('.b-map ymaps not defined');
			return;
		}

		var component = $(this);

		ymaps.ready(function () {
			var balloonTemplate = component.find('.b-map-balloonTemplate').html();

			// Creating an instance of the map and binding it to the created container.
			var myMap = new ymaps.Map(component[0], {
				center: component.data('center'),
				zoom: component.data('zoom'),
				controls: []
			}, {
				searchControlProvider: 'yandex#search'
			});
	
			function createPlacemark(params) {
				return new ymaps.Placemark(
					params.coord,
					{
						balloonContent: params.content,
					},
					{
						'draggable':false
					}
				);
			}

			var placemarks = component.find('.b-map-balloonContent').get().map(function (n) {
				return createPlacemark({
					coord: $(n).data('coord'),
					content: $(n).html()
				});
			});

			placemarks.forEach(function(placemark) {
				myMap.geoObjects.add(placemark);
			});

			myMap.events.add('click', function (e) {
				myMap.balloon.close();
			});

			myMap.behaviors.disable('scrollZoom');
			myMap.events.add('click', function(){
				myMap.behaviors.enable('scrollZoom')
			});

			myMap.controls.add(
				new ymaps.control.ZoomControl()
			);
			myMap.controls.add('zoomControl');
		});
	});
});